import React from 'react';
import { motion } from 'framer-motion';
interface BookMockupProps {
  className?: string;
}
export const BookMockup: React.FC<BookMockupProps> = ({
  className = ''
}) => {
  return <motion.div className={`relative w-full max-w-md mx-auto perspective-1000 ${className}`} initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} transition={{
    duration: 0.8,
    ease: 'easeOut'
  }} data-id="element-8">
      <div className="relative w-full aspect-[2/3] rounded-r-lg rounded-l-sm shadow-2xl transition-transform duration-500 hover:-translate-y-2 hover:rotate-y-[-5deg]" style={{
      transformStyle: 'preserve-3d',
      transform: 'rotateY(-15deg) rotateX(5deg)',
      boxShadow: '-15px 20px 30px rgba(0,0,0,0.2), inset 4px 0 10px rgba(255,255,255,0.2)'
    }} data-id="element-9">
        {/* Book Spine Edge */}
        <div className="absolute left-0 top-0 bottom-0 w-4 bg-gray-200 rounded-l-sm" style={{
        transform: 'translateZ(-1px) translateX(-2px)',
        boxShadow: 'inset -2px 0 5px rgba(0,0,0,0.1)'
      }} data-id="element-10" />

        {/* Book Cover */}
        <img src="https://cdn.magicpatterns.com/uploads/sdVzA2kG1wyPXXrbjQTPNK/ChatGPT_Image_17_may_2026,_01_26_05_p.m..png" alt="Resetea tu Cortisol en 21 Días - Cover" className="w-full h-full object-cover rounded-r-lg rounded-l-sm" style={{
        transform: 'translateZ(1px)'
      }} data-id="element-11" />

        {/* Pages Edge */}
        <div className="absolute right-0 top-1 bottom-1 w-2 bg-white" style={{
        transform: 'translateZ(-10px) translateX(10px) rotateY(90deg)',
        boxShadow: 'inset 0 0 5px rgba(0,0,0,0.1)'
      }} data-id="element-12" />
      </div>
    </motion.div>;
};